import React from 'react';
import {
    Group,
    List,
    Text,
    CloseOutlined,
    IconButton,
    ExternalLinkOutlined,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import * as Styled from '../styled';

const SuggestionGeneric = ({
    filterCategories,
    filterName,
    handleClick,
    handleRemoveRecentSuggestion,
    icon,
    isModal,
    isSelected = false,
    isRemoveSuggestionVisible = false,
    isNavigationItem = false,
    isDisabled = false,
    hoverRef,
}: {
    filterCategories?: string;
    filterName: string;
    handleClick?: () => void;
    handleRemoveRecentSuggestion?: (event: React.MouseEvent) => void;
    icon: React.ReactElement;
    isModal: boolean;
    isSelected?: boolean;
    isRemoveSuggestionVisible?: boolean;
    isNavigationItem?: boolean;
    hoverRef?: React.MutableRefObject<any>;
    isDisabled?: boolean;
}) => {
    const showAction = isRemoveSuggestionVisible || isNavigationItem;

    return (
        <List.Item
            ref={hoverRef}
            onClick={handleClick}
            minHeight="36px"
            py={isModal ? 12 : 0}
            isSelected={isSelected}
            aria-selected={isSelected}
            disabled={isDisabled}
        >
            <Styled.ListIcon>
                <Text contrast="low" lineHeight="unset">
                    {icon}
                </Text>
            </Styled.ListIcon>
            <Group alignItems="center" gutter="xs">
                <Group.Item>
                    <Text nbOfLines={1}>{filterName}</Text>
                </Group.Item>
                {!!filterCategories && (
                    <Group.Item>
                        <Text contrast="low" size="xs" fontWeight="400">
                            {filterCategories}
                        </Text>
                    </Group.Item>
                )}
            </Group>
            {showAction && (
                <List.ItemSecondaryAction>
                    {isRemoveSuggestionVisible ? (
                        <IconButton
                            icon={CloseOutlined}
                            variant="ghost"
                            kind="link"
                            size="md"
                            label={t`Remove`}
                            onClick={handleRemoveRecentSuggestion}
                        />
                    ) : (
                        <ExternalLinkOutlined color="neutral.300" size="md" />
                    )}
                </List.ItemSecondaryAction>
            )}
        </List.Item>
    );
};

export default SuggestionGeneric;
